module.exports = __webpack_public_path__ + "508cddbb4dc0737f4bc008e8fd1e9a0f.svg";